import React from "react";
import cx from "./cx";

/**
 * Cabecera de página: columna de título (+ subtítulo o línea de meta) y acciones
 * a la derecha. Presentacional pura: no lee redux ni pide datos.
 *  - as: etiqueta del título (h1 por defecto)
 *  - title: nodo del título (.rev-page-title)
 *  - subtitle: línea única bajo el título (.rev-page-subtitle)
 *  - meta: nodos sueltos de la línea de meta (.rev-pagehead__meta)
 *  - actions: botones a la derecha (.rev-pagehead__actions)
 *  - el resto de props (className, data-*, aria-*) van al contenedor
 */
const RevPageHead = ({ as: As = 'h1', title, subtitle, meta, actions, className, children, ...rest }) => (
    <div className={cx('rev-pagehead', className)} {...rest}>
        <div className="rev-page-titles">
            <As className="rev-page-title">{title}</As>
            {subtitle && <span className="rev-page-subtitle">{subtitle}</span>}
            {meta && <div className="rev-pagehead__meta">{meta}</div>}
        </div>
        {actions && <div className="rev-pagehead__actions">{actions}</div>}
        {children}
    </div>
);

export default RevPageHead;
